import React, {useEffect, useState} from 'react';
import styles from "../css/Account.module.css";
import Box from "components/inputs/Box";
import Button from "components/inputs/Button";
import { Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import Swal from "sweetalert2";

import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { accountActions } from "reducers/account";
import { commonActions } from "reducers/common";
import AccountService from "service/apiConfig/AccountService";
import { resetArray } from "service/util/resetArray";
import AccountModal from "./AccountModal";
import AccountSearch from "./AccountSearch";

const Account = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const user = useSelector(state => state.commonData.user);
    const accountList = useSelector(state => state.accountData.accountList);
    const limit = 8;
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(() => JSON.parse(window.localStorage.getItem('page')) || 1);
    const offset = (page - 1) * limit;

    const { role } = user;
    const owner = role.name === "owner";

    useEffect(() => {
        dispatch(commonActions.trueIsLoading());
        AccountService.getAll()
            .then(response => {
                const arr = resetArray(response)
                dispatch(accountActions.setAccountList(arr))
                dispatch(commonActions.falseIsLoading());
            })
            .catch(err => console.log(err));
    }, [dispatch])

    useEffect(() => {
        window.localStorage.setItem('accountPage', JSON.stringify(pageCount));
        setPage(pageCount)
    }, [page, pageCount])

    const onCreateAccount = () => {
        history.push("/setting/create/account");
    }

    const handleOpenDetail = (id, item) => {
        dispatch(accountActions.setOpenDetail(true));
        dispatch(accountActions.setAccountDetail(item));
    }

    const handlePageChange = (e, value) => {
        setPage(value)
        setPageCount(value)
    }

    const onDeleted = (id) => {
        Swal.fire({
            title: '정말 삭제하시겠습니까 ?',
            icon: 'warning',
            confirmButtonText: '네',
            cancelButtonText: '아니오',
            showCancelButton: true,
            confirmButtonColor: '#D55240',
        }).then(result => {
            if (result.isConfirmed) {
                AccountService.deleted(id)
                    .then(response => {
                        const list = accountList.filter(item => item.id !== id);
                        dispatch(accountActions.setAccountList(list));
                        return true;
                    })
                    .catch(err => console.log(err));
            }
        });
    }
    return (
        <section className={`sectionWrap ${styles.accountWrap}`}>
            <header>
                <h2>계정 관리</h2>
                {owner &&
                    <Button onClick={onCreateAccount} style={{ background: "#A2B521" }}>
                        등록
                    </Button>
                }
            </header>
            <Box>
                <Box style={{marginBottom: '1rem'}}>
                    <AccountSearch />
                </Box>
                <TableContainer className={styles.accountList} component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align={"center"} style={{ maxWidth: "40px" }}>No</TableCell>
                                <TableCell>아이디</TableCell>
                                <TableCell>사용자 이름</TableCell>
                                <TableCell>권한</TableCell>
                                <TableCell>카테고리</TableCell>
                                {owner && <TableCell> </TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {accountList.slice(offset, offset + limit).map((row, index) => (
                                <TableRow
                                    key={row.id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell align={"center"} style={{ maxWidth: "40px" }}>
                                        <p>{row.index}</p>
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.username}
                                    </TableCell>
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{row.role.name}</TableCell>
                                    <TableCell>{row.role.category}</TableCell>
                                    {owner &&
                                    <TableCell align="right">
                                        <Button onClick={() => handleOpenDetail(row.id, row)} style={{ background: "#dfa78f" }}>수정</Button>
                                        <Button onClick={() => onDeleted(row.id)} style={{ background: "#D55240", marginLeft: "0.2rem" }}>삭제</Button>
                                    </TableCell>
                                    }
                                </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {accountList.length < 1 && <p style={{ padding: "3rem" }} className={"noData"}>데이터가 없습니다.</p>}
                {accountList.length > 1 && <Pagination className={"pagination"} page={page} onChange={handlePageChange} count={Math.ceil(accountList.length / limit)} />}
            </Box>
            <AccountModal />
        </section>
    );
};

export default Account;